"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=branch.dto.js.map